import script from "./voiceReportConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./voiceReportConfirm.vue?vue&type=script&setup=true&lang=js"

import "./voiceReportConfirm.vue?vue&type=style&index=0&id=05134688&lang=scss&scoped=true"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05134688"]])

export default __exports__